import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import { App } from 'vue';

// exported so non-component code (e.g. useLocale's module singleton) can invalidate queries
// without requiring an injection context
export const queryClient = new QueryClient();

export default function (app: App): void {
  app.use(VueQueryPlugin, { queryClient });
}
